enum CouponStatusId {
    Active = 1,
    Passive = 2,
    Expired = 3,
    Exhausted = 4,
    PendingForApproval = 5,
    Deleted = 6,
    Cancelled = 7,
    Refunded = 8,
}
export { CouponStatusId };
